import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
 * * * GENERAL UTILITIES * * *
 */

/*
 * Array utilities
 */
var Utilities =
/*#__PURE__*/
function () {
  function Utilities() {
    _classCallCheck(this, Utilities);
  }

  _createClass(Utilities, null, [{
    key: "pushToArrIfMissing",

    /**
     * Get numerical index for a given entry in an array
     *
     * @param array - The array to look for the entry inside.
     *
     * @param entry - The entry to look for in the array.
     *
     */
    value: function pushToArrIfMissing(array, entry) {
      var index = array.indexOf(entry);

      if (index === -1) {
        array.push(entry);
      }
    }
    /**
     * Checks if entry exists in array
     *
     * @param array - The array to look for the entry inside.
     *
     * @param entry - The entry to look for in the array.
     *
     * @return true if is missing, otherwise false.
     */

  }, {
    key: "isMissingFromArray",
    value: function isMissingFromArray(array, entry) {
      var index = array.indexOf(entry);
      return index === -1 ? true : false;
    }
  }]);

  return Utilities;
}();

export { Utilities as default };